import { render, staticRenderFns } from "./generalPayPopup.vue?vue&type=template&id=545be338"
import script from "./generalPayPopup.vue?vue&type=script&lang=js"
export * from "./generalPayPopup.vue?vue&type=script&lang=js"
import style0 from "./generalPayPopup.vue?vue&type=style&index=0&id=545be338&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports